var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0261 20.0176C20.6215 20.0176 20.2937 20.3455 20.2937 20.75C20.2937 21.1545 20.6215 21.4824 21.0261 21.4824H30.0607C30.4652 21.4824 30.7931 21.1545 30.7931 20.75V11.4237C30.7931 11.0192 30.4652 10.6913 30.0607 10.6913C29.6562 10.6913 29.3283 11.0192 29.3283 11.4237V18.9819L16.5161 6.16976C16.2301 5.88377 15.7664 5.88377 15.4804 6.16976L11.4809 10.1692L2.45367 1.14195L1.41797 2.1776L10.9631 11.7227C11.2491 12.0087 11.7128 12.0087 11.9988 11.7227L15.9983 7.72326L28.2926 20.0176H21.0261Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDown);
export default __webpack_public_path__ + "static/media/report-down.8330545d16c043cadfa568b4dec609f8.svg";
export { ForwardRef as ReactComponent };